import { styled } from 'styletron-react'

export default styled('section', {
  boxSizing: 'border-box',
  display: 'flex',
  flexWrap: 'wrap',
})
